import request from '@/utils/request'

// 文件下载进度
export function operateProgress(data) {
  return request({
    url: '/porgan/g/system/operateProgress/details',
    method: 'post',
    data
  })
}

// 文件导入测试
export function operateProgress_inport_test(data) {
  return request({
    url: '/porgan/g/wuguan/param/pat/point/inportExcel',
    method: 'post',
    data
  })
}
// 组织架构树
export function accountManagementTreeData(data) {
  return request({
    url: '/porgan/g/common/choseUser/organTreeData',
    method: 'post',
    data
  })
}
// 根据组织架构树 选择用户
export function busUserUserData(data) {
  return request({
    url: '/porgan/g/common/choseUser/userListData',
    method: 'post',
    data
  })
}
// 根据ID 检索用户
export function choseBusUser_selectUserInfo(data) {
  return request({
    url: '/porgan/g/common/choseUser/selectUserData',
    method: 'post',
    data
  })
}
// 选择项目 分期
export function commons_busProject(data) {
  return request({
    url: '/porgan/g/common/choseProject/projectTreeData',
    method: 'post',
    data
  })
}

// 【选择组织】获取组织架构树数据
export function choseOrganOrganTreeData(data) {
  return request({
    url: '/porgan/g/common/choseOrgan/organTreeData',
    method: 'post',
    data
  })
}
// 【选择角色】获取角色树
export function choseRoleTreeData(data) {
  return request({
    url: '/porgan/g/common/choseRole/roleTreeData',
    method: 'post',
    data
  })
}

//  获取楼栋房间和部位树

export function buildingTree(params) {
  return request({
    url: '/porgan/g/pzhgc-p/planInfo/condition/buildingTree',
    method: 'get',
    params
  })
}

// 根据承建商获取组织
export function busContractorUserOrgan(params) {
  return request({
    url: '/porgan/g/busContractor/info/user/organ',
    method: 'get',
    params
  })
}
// 获取操作记录
export function getOperateList(data) {
  return request({
    url: '/porgan/g/plog-p/userOperate/listData',
    method: 'post',
    data
  })
}
// 获取项目组织树使用情况
export function getUseTree(params) {
  return request({
    url: '/porgan/g/common/choseCompamy/CompanyProject',
    method: 'get',
    params
  })
}
// Excel导出带进度条
export function exportExcel(data) {
  return request({
    url: '/porgan/g/pzhlw/p/progress/exportExcel',
    method: 'post',
    data
  })
}

// Excel导出PDF
export function exportPdf(data) {
  return request({
    url: '/porgan/g/pzhlw/p/progress/exportPdf',
    method: 'post',
    data
  })
}

// Excel导入带进度条
export function importExcel(data) {
  return request({
    url: '/porgan/g/pzhlw/p/progress/importExcel',
    method: 'post',
    data
  })
}
// 查询进度
export function getProgressInfo(params) {
  return request({
    url: '/porgan/g/pzhlw/p/progress/getProgressInfo',
    method: 'get',
    params
  })
}

